export default class AccordionList {

  /**
   * Constructor
   */
  constructor(container) {
    if (container.dataset.inited) { return; }
    // Public vars
    this.container = container;
    this.showingId = null;

    // Add click listeners to each button
    var buttons = this.container.querySelectorAll('.accordion__label button');
    buttons.forEach((el) => el.addEventListener('click', this.toggleBody.bind(this)));

    container.dataset.inited = true;
  }


  /**
   * Event handler - decides what to show or hide
   */
  toggleBody(event) {

    var bodyId = event.currentTarget.dataset.toggle;
    var body = this.container.querySelector('#' + bodyId);

    // Is something showing?
    if (this.showingId) {
      // Is that something showing the same as what got clicked?
      if (this.showingId === bodyId) {
        this.hideBody(body);
      } else {
        var showingBody = this.container.querySelector('#' + this.showingId);
        this.hideBody(showingBody);
        this.showBody(body);
      }
    } else {
      this.showBody(body);
    }
  }


  /**
   * Event handler - shows a panel body
   */
  showBody(body) {
    body.parentElement.classList.add('is-expanded');
    this.showingId = body.id;
  }


  /**
   * Event handler - hides a panel body
   */
  hideBody(body) {
    body.parentElement.classList.remove('is-expanded');
    this.showingId = null;
  }

}
